import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { fetchCustomers, selectAllCustomers } from '../../../slices/customers/customersSlice';
import { selectAllCompanies } from '../../../slices/companies/companiesSlice';

export const useCustomerProfiles = () => {
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectAllCompanies)[0];
  const customers = useAppSelector(selectAllCustomers);
  const customersCount = useAppSelector((state) => state.customers.customersCount);
  const customersLoading = useAppSelector((state) => state.customers.status);
  const [cardView, setCardView] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchString, setSearchString] = useState('');
  const [searchStringInputValue, setSearchStringInputValue] = useState('');
  const [searchCleared, setSearchCleared] = useState(false);

  const searchParams: {
    company_id: number;
    sort?: string;
    order?: string;
    name?: string;
    page?: number;
  } = useMemo(
    () => ({
      company_id: company?.id,
      name: searchString,
      sort: 'name',
      order: 'ASC',
    }),
    [searchString, company?.id]
  );

  const getNextPage = () => {
    dispatch(
      fetchCustomers({
        ...searchParams,
        page: currentPage + 1,
      })
    );
    setCurrentPage(currentPage + 1);
  };

  const getRequestedPage = (page: number) => {
    dispatch(
      fetchCustomers({
        ...searchParams,
        page,
      })
    );
    setCurrentPage(page);
  };

  const getPrevPage = () => {
    dispatch(
      fetchCustomers({
        ...searchParams,
        page: currentPage - 1,
      })
    );
    setCurrentPage(currentPage - 1);
  };

  const setSearchStringValue = useCallback(() => {
    if (customersLoading !== 'loading') {
      setSearchString(searchStringInputValue);
    }
  }, [customersLoading, setSearchString, searchStringInputValue]);

  const resetSearchFilter = useCallback(() => {
    setSearchString('');
    setSearchStringInputValue('');
    setSearchCleared(true);
    delete searchParams.name;
    //dispatch(fetchCustomers({ ...searchParams, page: currentPage }));
  }, [/*dispatch, */ searchParams, setSearchCleared, setSearchString]);

  const fetchCustomersRequest = useCallback(() => {
    //if (company) {
    dispatch(fetchCustomers({ ...searchParams, page: currentPage }));
    //}
  }, [/*company,*/ currentPage, dispatch, searchParams]);

  useEffect(() => {
    fetchCustomersRequest();
  }, [fetchCustomersRequest]);

  useEffect(() => {
    setSearchStringValue();
  }, [setSearchStringValue]);

  return {
    cardView,
    setCardView,
    customers,
    customersLoading,
    getNextPage,
    getPrevPage,
    getRequestedPage,
    currentPage,
    setCurrentPage,
    customersCount,
    searchString,
    setSearchString,
    resetSearchFilter,
    searchCleared,
    setSearchCleared,
    searchStringInputValue,
    setSearchStringInputValue,
  };
};
